export class Ec2TemplateParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "instanceType",
            "baseName": "instanceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "inheritInstanceType",
            "baseName": "inheritInstanceType",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "kmsKeyArn",
            "baseName": "kmsKeyArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "keepOriginalTags",
            "baseName": "keepOriginalTags",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "additionalTags",
            "baseName": "additionalTags",
            "type": "Array<Ec2TemplateParamsAdditionalTagsInner>",
            "format": ""
        },
        {
            "name": "nameTemplate",
            "baseName": "nameTemplate",
            "type": "string",
            "format": ""
        },
        {
            "name": "startAfterRestore",
            "baseName": "startAfterRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "targetAccountId",
            "baseName": "targetAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "targetRegion",
            "baseName": "targetRegion",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Ec2TemplateParams.attributeTypeMap;
    }
    constructor() {
    }
}
